import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUserListData } from "./rolebaseAPI";
export interface UserListState {
  userListData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: UserListState = {
  userListData: [],
  status: "idle",
};

export const GetUserListData = createAsyncThunk("UserList/fetchUserListData", async (data:any) => {
  const response = await fetchUserListData(data);
  return response;
});

export const UserListSlice = createSlice({
  name: "UserList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUserListData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUserListData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetUserListData.fulfilled, (state, action) => {
        state.status = "success";
        state.userListData = action.payload.user;
      });
  },
});

export const {} = UserListSlice.actions;

export const selectUserListData = (state: RootState) => {
  return state.UserList.userListData;
};

export default UserListSlice.reducer;
